"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.borderWidths = void 0;
exports.borderWidths = {
    sm: "border-2",
    md: "border-4",
    lg: "border-8",
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYm9yZGVyV2lkdGguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvc3R5bGVzL2NvbmZpZ3MvYm9yZGVyV2lkdGgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxZQUFZLEdBQTJCO0lBQ2xELEVBQUUsRUFBRSxVQUFVO0lBQ2QsRUFBRSxFQUFFLFVBQVU7SUFDZCxFQUFFLEVBQUUsVUFBVTtDQUNmLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgY29uc3QgYm9yZGVyV2lkdGhzOiBSZWNvcmQ8c3RyaW5nLCBzdHJpbmc+ID0ge1xuICBzbTogXCJib3JkZXItMlwiLFxuICBtZDogXCJib3JkZXItNFwiLFxuICBsZzogXCJib3JkZXItOFwiLFxufTtcbiJdfQ==